function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".successa{fill:#66ba63;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2310.846 -489.417)"
}, /*#__PURE__*/React.createElement("path", {
  className: "successa",
  d: "M2324.1,490.81a11.357,11.357,0,1,1-11.357,11.357A11.37,11.37,0,0,1,2324.1,490.81m0-1.893a13.25,13.25,0,1,0,13.25,13.25,13.25,13.25,0,0,0-13.25-13.25Z",
  transform: "translate(0 0.5)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(944.255 -210.589)"
}, /*#__PURE__*/React.createElement("path", {
  className: "successa",
  d: "M1384.7,718.256a.957.957,0,0,1-.676-1.633l7.336-7.336a.957.957,0,0,1,1.353,1.353l-7.336,7.336A.954.954,0,0,1,1384.7,718.256Z",
  transform: "translate(-6.917)"
}), /*#__PURE__*/React.createElement("path", {
  className: "successa",
  d: "M1377.787,727a.955.955,0,0,1-.677-.28l-3.239-3.239a.957.957,0,1,1,1.353-1.353l3.239,3.239a.957.957,0,0,1-.677,1.633Z",
  transform: "translate(0 -8.748)"
})));

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26.5,
    height: 26.5,
    viewBox: "0 0 26.5 26.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success.8edc5bdf.svg";
export { ForwardRef as ReactComponent };